module.exports = __webpack_public_path__ + "assets/img/19b8-ps.svg";